<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4BBDL6/tc-custom/9781488022883.jpg?1724859935558" alt="This image is the cover for the book Confessions of a Domestic Failure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confessions of a Domestic Failure
      </h1>
      <p class="bookDescription body article font2">
        <b>From the creator of <i>The Honest Toddler</i> comes a fiction debut “perfect for readers looking for a funny, realistic look at motherhood” (<i>Booklist</i>, starred review).</b><br/><br/>There are good moms and bad moms . . . and then there are hot-mess moms. <i>Confessions of a Domestic Failure</i> introduces readers to Ashley Keller, career girl turned stay-at-home mom who’s trying to navigate the world of Pinterest-perfect mommies.<br/><br/>When Ashley gets the chance to enroll in a mommy-blog maven’s Motherhood Better boot camp, she jumps at the chance to become the perfect mom she’s always wanted to be. But the pursuit of perfection has a way of going perfectly wrong.<br/><br/>With her razor-sharp wit, Bunmi Laditan creates an unforgettable and hilariously relatable character while lambasting the social pressures every new mother faces.<br/><br/><b>“Freaking hilarious. This is the novel moms have been waiting for.” —Jenny Lawson, <i>#1 New York Times</i>–bestselling author of <i>Let’s Pretend This Never Happened</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bunmi Laditan
      </h2>
      
      <p class="authorDescription body article">Bunmi Laditan is an award-winning, Webby-nominated writer from California who lives in Quebec, Canada, with her family. She's contributed to the New York Times, Parenting Magazine and The Huffington Post, and is best known for the satirical Twitter account Honest Toddler.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16c76b6a